import React, { Component } from 'react';
import TranscriptTextView from './TranscriptTextView';
import Animator from '../Animator';

/**
 * note as a fragment these nodes will be expanding linearly from
 * the container's insertion point in with the Player layouts.
 */
class TranscriptView extends Component {
  render() {
    return (
      <React.Fragment>
        <Animator />
        <TranscriptTextView {...this.props} />
      </React.Fragment>
    );
  }
}

export default TranscriptView;
